import Page403 from "./page-403";
const FORBIDDEN_ERROR_PATH = "/403";
export { FORBIDDEN_ERROR_PATH, Page403 };
